<template>
  <div class="control-wrapper">
    <div class="container">
      <div class="header">
        <div class="tabs-container">
          <div class="custom-van-tabs">
            <van-tabs
              :key="'tabs-strip-' + tabsStripKey"
              v-model="localActiveTab"
              type="card"
              swipeable
              ref="tabs"
            >
              <van-tab :title="$t('append_field.program')" />
              <van-tab v-if="showBg" :title="$t('append_field.control_addbackground')">
                <template #title>
                  <span>{{ dynamicTitle('background') }}</span>
                  <van-icon
                    name="/static/images/program/del.png"
                    class="delete-icon"
                    @click.stop="confirmRemoveTab(1, 'background')"
                  />
                </template>
              </van-tab>
              <van-tab
                v-for="(tab, index) in dynamicTabs"
                :key="tab.id"
                title-class="sortable-dynamic-tab"
                :class="{ dragging: isDragging && dragStartIndex === index }"
                @touchstart.native="onTabTouchStart($event, index)"
                @touchmove.native="onTabTouchMove"
                @mousedown.native="onTabMouseDown($event, index)"
                @dragstart.native.prevent
              >
                <template #title>
                  <div class="tab-title-wrapper" :data-control-index="index">
                    <span>{{ dynamicTitle(tab.content) }}</span>
                  </div>
                  <van-icon
                    name="/static/images/program/del.png"
                    class="delete-icon"
                    @click.stop="confirmRemoveTab(index, tab.content)"
                  />
                </template>
              </van-tab>
            </van-tabs>
          </div>
        </div>
        <div class="tabs-btn">
          <van-button @click="addTab">
            <template #icon>
              <img
                src="/static/images/program/add.png"
                style="height: 40px; display: flex; align-items: center; justify-content: center"
              >
            </template>
          </van-button>
        </div>
      </div>
      <div class="playMode-content">
        <div v-if="localActiveTab === 0">
          <div class="list">
            <van-row>
              <span class="cell-title">{{ $t('append_field.task_name') }}</span>
              <div class="progremList">
                <van-field :value="taskName" disabled />
              </div>
            </van-row>
            <van-row>
              <span class="cell-title">{{ $t('append_field.playMode') }}</span>
              <div class="progremList">
                <van-radio-group v-model="localTaskPlayMode" direction="horizontal">
                  <van-radio name="1">{{ $t('append_field.replaceMode') }}</van-radio>
                  <van-radio name="2">{{ $t('append_field.appendMode') }}</van-radio>
                  <van-radio name="3">{{ $t('append_field.apotpatterns') }}</van-radio>
                </van-radio-group>
              </div>
            </van-row>
          </div>
          <div  class="list">
            <span class="cell-title">{{ $t('append_field.dateRange') }}</span>
            <van-row>
              <van-field
                :value="startData"
                is-link
                input-align="right"
                readonly
                :label="$t('append_field.start_date')"
                @click="showDatePicker('sData')"
              />
            </van-row>
            <van-row>
              <van-field
                :value="endData"
                is-link
                readonly
                input-align="right"
                :label="$t('append_field.end_date')"
                @click="showDatePicker('eData')"
              />
            </van-row>
            <span class="cell-title">{{ $t('append_field.timeRange') }}</span>
            <van-row>
              <van-field
                :value="startTime"
                is-link
                input-align="right"
                readonly
                :label="$t('append_field.start_time')"
                @click="showDatePicker('sTime')"
              />
            </van-row>
            <van-row>
              <van-field
                :value="endTime"
                is-link
                readonly
                input-align="right"
                :label="$t('append_field.end_time')"
                @click="showDatePicker('eTime')"
              />
            </van-row>
            <span class="cell-title">{{ $t('append_field.taskPeriod') }}</span>
            <van-row class="weekliWrap">
              <div
                v-for="day in weekDays"
                :key="day.key"
                class="weekli"
                :class="{ active: day.active }"
                @click="weekChoose(day.key)"
              >{{ day.label }}</div>
            </van-row>
          </div>
        </div>
        <div v-else class="list">
          <imgsettings
            v-if="imgsetting && isMpListValid(panelControlIndex)"
            :lists="componentsList[panelControlIndex].mpList"
            @ondele="ondele"
          />
          <videosettings
            v-if="videosetting && isMpListValid(panelControlIndex)"
            :lists="componentsList[panelControlIndex].mpList"
            @ondele="ondele"
          />
          <audioSettings
            v-if="audioSetting && isMpListValid(panelControlIndex)"
            :lists="componentsList[panelControlIndex].mpList"
            @ondele="ondele"
          />
          <docSettings
            v-if="docSetting && isMpListValid(panelControlIndex)"
            :lists="componentsList[panelControlIndex].mpList"
            @ondele="ondele"
          />
          <mixtureSettings
            v-if="mixtureSettings && isMpListValid(panelControlIndex)"
            :lists="componentsList[panelControlIndex].mpList"
            @ondele="ondele"
          />
          <fontsettings
            v-if="subtitlesetting && isTxListValid(panelControlIndex)"
            :key="`font-${panelControlIndex}-${componentsList[panelControlIndex]?.id}`"
            :text="componentsList[panelControlIndex]"
            @setText="getText"
            @close="close"
          />
          <streamings
            v-if="streaming && isTxListValid(panelControlIndex)"
            :key="`stream-${panelControlIndex}-${componentsList[panelControlIndex]?.id}`"
            :text="componentsList[panelControlIndex]"
            @setText="getText"
            @close="close"
          />
          <websettings
            v-if="websetting && isTxListValid(panelControlIndex)"
            :key="`web-${panelControlIndex}-${componentsList[panelControlIndex]?.id}`"
            :text="componentsList[panelControlIndex]"
            @setText="getText"
            @close="close"
          />
          <backgroundsetting v-if="backgroundList" :pageBg="bgImg" @ondele="onClearBg" />
          <dateSettings
            v-if="dateSetting && isTxListValid(panelControlIndex)"
            :text="componentsList[panelControlIndex]"
            @ondele="ondele"
          />
        </div>
      </div>
    </div>

    <van-overlay v-show="showControl" class="overlay" @click="showControl = false">
      <div class="wrapper" @click.stop>
        <van-icon
          v-for="button in buttonList"
          :key="button.id"
          class="icon-container"
          @click="onPickControl(button.content)"
        >
          <img :src="button.icon" alt="icon" style="height: 50px">
          <span class="overlay-text">{{ dynamicTitle(button.content) }}</span>
        </van-icon>
      </div>
    </van-overlay>

    <van-popup v-model="isShowStartData" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t('append_field.selectStartDate')"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="startDataChoose"
        @cancel="isShowStartData = false"
      />
    </van-popup>
    <van-popup v-model="isShowEndData" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t('append_field.selectEndDate')"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="endDataChoose"
        @cancel="isShowEndData = false"
      />
    </van-popup>
    <van-popup v-model="isShowStartTime" position="bottom">
      <van-datetime-picker
        type="time"
        :title="$t('append_field.selectStartTime')"
        @confirm="startTimeChoose"
        @cancel="isShowStartTime = false"
      />
    </van-popup>
    <van-popup v-model="isShowEndTime" position="bottom">
      <van-datetime-picker
        type="time"
        :title="$t('append_field.selectEndTime')"
        @confirm="endTimeChoose"
        @cancel="isShowEndTime = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import { Dialog } from 'vant'
import { mapActions, mapState } from 'vuex'
import audioSettings from '@/components/audioSettings.vue'
import fontsettings from '@/components/fontsettings.vue'
import videosettings from '@/components/videosettings.vue'
import docSettings from '@/components/docSettings.vue'
import websettings from '@/components/websettings.vue'
import imgsettings from '@/components/imgsettings.vue'
import dateSettings from '@/components/dateSettings.vue'
import mixtureSettings from '@/components/mixtureSettings.vue'
import backgroundsetting from '@/components/backgroundsetting.vue'
import streamings from '@/components/streamings.vue'

export default {
  name: 'EditorControlPanel',
  components: {
    streamings,
    backgroundsetting,
    mixtureSettings,
    dateSettings,
    imgsettings,
    websettings,
    docSettings,
    videosettings,
    fontsettings,
    audioSettings,
  },
  props: {
    activeTab: {
      type: Number,
      required: true,
    },
    showBg: {
      type: Boolean,
      default: false,
    },
    dynamicTabs: {
      type: Array,
      default: () => [],
    },
    taskName: {
      type: String,
      default: '',
    },
    taskPlayMode: {
      type: String,
      default: '1',
    },
    startData: {
      type: String,
      default: '',
    },
    endData: {
      type: String,
      default: '',
    },
    startTime: {
      type: String,
      default: '00:00:00',
    },
    endTime: {
      type: String,
      default: '23:59:00',
    },
    isActive1: { type: Boolean, default: true },
    isActive2: { type: Boolean, default: true },
    isActive3: { type: Boolean, default: true },
    isActive4: { type: Boolean, default: true },
    isActive5: { type: Boolean, default: true },
    isActive6: { type: Boolean, default: true },
    isActive7: { type: Boolean, default: true },
    minDate: {
      type: Date,
      default: () => new Date(2024, 0, 1),
    },
    maxDate: {
      type: Date,
      default: () => new Date(2100, 10, 5),
    },
  },
  data() {
    return {
      isDragging: false,
      dragStartIndex: -1,
      dragFromControlIndex: -1,
      tabSortableInstance: null,
      tabsStripKey: 0,
      showControl: false,
      buttonList: [
        { id: 1, content: 'img', icon: '/static/images/program/img.png' },
        { id: 2, content: 'video', icon: '/static/images/program/video.png' },
        { id: 3, content: 'audio', icon: '/static/images/program/audio.png' },
        { id: 4, content: 'mixture', icon: '/static/images/program/mixture.png' },
        { id: 5, content: 'doc', icon: '/static/images/program/doc.png' },
        { id: 6, content: 'date', icon: '/static/images/program/date.png' },
        { id: 7, content: 'weeks', icon: '/static/images/program/weeks.png' },
        { id: 8, content: 'time', icon: '/static/images/program/time.png' },
        { id: 9, content: 'subtitle', icon: '/static/images/program/subtitle.png' },
        { id: 10, content: 'streaming', icon: '/static/images/program/streaming.png' },
        { id: 11, content: 'webPage', icon: '/static/images/program/webPage.png' },
        { id: 12, content: 'background', icon: '/static/images/program/addbackground.png' },
        { id: 13, content: 'hdmin', icon: '/static/images/program/hdmin.png' },
      ],
      isShowStartData: false,
      isShowEndData: false,
      isShowStartTime: false,
      isShowEndTime: false,
      imgsetting: false,
      videosetting: false,
      subtitlesetting: false,
      websetting: false,
      hdmin: false,
      streaming: false,
      bgImg: '',
      backgroundList: false,
      mixtureSettings: false,
      docSetting: false,
      dateSetting: false,
      audioSetting: false,
    }
  },
  computed: {
    ...mapState({
      controlIndex: state => state.controlIndex,
      componentsList: state => state.componentsList,
    }),
    fixedTabCount() {
      return this.showBg ? 2 : 1
    },
    localActiveTab: {
      get() {
        return this.activeTab
      },
      set(val) {
        this.$emit('update:active-tab', val)
      },
    },
    localTaskPlayMode: {
      get() {
        return this.taskPlayMode
      },
      set(val) {
        this.$emit('update:task-play-mode', val)
      },
    },
    /** 与当前选中的页签下标一致，避免交换后 controlIndex 与 activeTab 错位 */
    panelControlIndex() {
      const ci = this.tabIndexToControlIndex(this.localActiveTab)
      return ci == null ? -1 : ci
    },
    weekDays() {
      const keys = ['1', '2', '3', '4', '5', '6', '7']
      const labels = [
        this.$t('append_field.mon'),
        this.$t('append_field.tue'),
        this.$t('append_field.wed'),
        this.$t('append_field.thu'),
        this.$t('append_field.fri'),
        this.$t('append_field.sat'),
        this.$t('append_field.sun'),
      ]
      const flags = [
        this.isActive1,
        this.isActive2,
        this.isActive3,
        this.isActive4,
        this.isActive5,
        this.isActive6,
        this.isActive7,
      ]
      return keys.map((key, i) => ({
        key,
        label: labels[i],
        active: flags[i],
      }))
    },
  },
  watch: {
    activeTab(val) {
      this.handleTabChange(val)
    },
    showBg() {
      // van-tabs 无法可靠响应 v-if 动态增删的页签；等父组件 activeTab 等 prop 落地后再重建
      this.$nextTick(() => {
        this.bumpTabsStripKey()
        this.$nextTick(() => {
          this.handleTabChange(this.activeTab)
          this.refreshSortable()
        })
      })
    },
  },
  mounted() {
    this.refreshSortable()
    this.handleTabChange(this.activeTab)
  },
  beforeDestroy() {
    this.destroySortable()
  },
  methods: {
    ...mapActions(['addSubtitle']),

    dynamicTitle(content) {
      const titleMap = {
        img: this.$t('append_field.image'),
        video: this.$t('append_field.control_video'),
        audio: this.$t('append_field.audio'),
        mixture: this.$t('append_field.mixture'),
        doc: this.$t('append_field.document'),
        date: this.$t('append_field.date'),
        weeks: this.$t('append_field.weeks'),
        time: this.$t('append_field.time'),
        webPage: this.$t('append_field.webPage'),
        streaming: this.$t('append_field.media'),
        subtitle: this.$t('append_field.subtitle'),
        background: this.$t('append_field.control_addbackground'),
        hdmin: 'HDMI-IN',
      }
      return titleMap[content] || content
    },

    /** 父组件在交换页签、加载模板后调用 */
    bumpTabsStripKey() {
      this.tabsStripKey += 1
    },

    refreshSortable() {
      this.destroySortable()
      this.$nextTick(() => {
        this.initSortable()
      })
    },

    destroySortable() {
      if (!this.tabSortableInstance) return
      try {
        this.tabSortableInstance.destroy()
      } catch (e) {
        /* ignore */
      }
      this.tabSortableInstance = null
    },

    readControlIndexFromNavEl(navEl) {
      if (!navEl) return -1
      const marked = navEl.querySelector('[data-control-index]')
      if (marked) {
        const n = parseInt(marked.getAttribute('data-control-index'), 10)
        if (!Number.isNaN(n)) return n
      }
      const tabsRef = this.$refs.tabs
      if (!tabsRef || !tabsRef.$el) return -1
      const nav = tabsRef.$el.querySelector('.van-tabs__nav')
      if (!nav) return -1
      const draggables = Array.from(nav.children).filter(
        (el) => el.classList.contains('sortable-dynamic-tab') || el.querySelector('[data-control-index]')
      )
      return draggables.indexOf(navEl)
    },

    revertSortableDom(evt) {
      if (!evt || evt.oldIndex === evt.newIndex || !evt.from || !evt.item) return
      const parent = evt.from
      const item = evt.item
      parent.removeChild(item)
      if (evt.oldIndex < evt.newIndex) {
        parent.insertBefore(item, parent.children[evt.oldIndex])
      } else {
        parent.insertBefore(item, parent.children[evt.oldIndex] || null)
      }
    },

    initSortable() {
      const tabsRef = this.$refs.tabs
      if (!tabsRef || !tabsRef.$el) return
      const tabsNav = tabsRef.$el.querySelector('.van-tabs__nav')
      if (!tabsNav || !tabsNav.querySelector('[data-control-index]')) return

      this.tabSortableInstance = Sortable.create(tabsNav, {
        animation: 180,
        delay: 300,
        delayOnTouchStart: true,
        touchStartThreshold: 10,
        draggable: '.sortable-dynamic-tab',
        filter: '.delete-icon',
        preventOnFilter: true,
        handle: '.tab-title-wrapper',
        onStart: (evt) => {
          this.isDragging = true
          this.dragFromControlIndex = this.readControlIndexFromNavEl(evt.item)
          this.dragStartIndex = this.dragFromControlIndex
          evt.item.style.opacity = '0.8'
          evt.item.style.transform = 'scale(1.05)'
          document.body.style.overflow = 'hidden'
          if (navigator.vibrate) navigator.vibrate(50)
        },
        onEnd: (evt) => {
          this.isDragging = false
          evt.item.style.opacity = ''
          evt.item.style.transform = ''
          document.body.style.overflow = ''

          const nav = evt.from
          const draggables = nav
            ? Array.from(nav.children).filter(
              (el) => el.classList.contains('sortable-dynamic-tab') || el.querySelector('[data-control-index]')
            )
            : []
          const fromControlIndex = this.dragFromControlIndex
          const toControlIndex = draggables.indexOf(evt.item)

          this.revertSortableDom(evt)

          if (
            fromControlIndex >= 0 &&
            toControlIndex >= 0 &&
            fromControlIndex !== toControlIndex &&
            fromControlIndex < this.dynamicTabs.length &&
            toControlIndex < this.dynamicTabs.length
          ) {
            this.$emit('tab-swap', fromControlIndex, toControlIndex)
          }
          this.dragFromControlIndex = -1
          this.dragStartIndex = -1
        },
      })
    },

    isDynamicTabIndex(tabIndex) {
      return tabIndex >= this.fixedTabCount
    },

    tabIndexToControlIndex(tabIndex) {
      const t = Number(tabIndex)
      if (Number.isNaN(t) || t < 0) return null
      if (t === 0) return null
      if (this.showBg && t === 1) return null
      const ci = t - this.fixedTabCount
      if (ci < 0 || ci >= this.componentsList.length) return null
      return ci
    },

    handleTabChange(tabIndex) {
      this.resetControlSettings()
      if (tabIndex === 0) return

      if (this.showBg && tabIndex === 1) {
        this.backgroundList = true
        return
      }
      const controlIndex = this.tabIndexToControlIndex(tabIndex)
      if (controlIndex != null) {
        this.$emit('activate-control', controlIndex)
      }
    },

    /** 父组件在画布点击激活时调用，只切换右侧设置区，不重复改 activeTab */
    applySettingsPanel(type) {
      this.resetControlSettings()
      switch (type) {
        case 'img':
          this.imgsetting = true
          break
        case 'video':
          this.videosetting = true
          break
        case 'subtitle':
          this.subtitlesetting = true
          break
        case 'hdmin':
          this.hdmin = true
          break
        case 'webPage':
          this.websetting = true
          break
        case 'streaming':
          this.streaming = true
          break
        case 'mixture':
          this.mixtureSettings = true
          break
        case 'doc':
          this.docSetting = true
          break
        case 'audio':
          this.audioSetting = true
          break
        default:
          this.dateSetting = true
          break
      }
    },

    resetControlSettings() {
      this.imgsetting = false
      this.videosetting = false
      this.subtitlesetting = false
      this.websetting = false
      this.hdmin = false
      this.streaming = false
      this.backgroundList = false
      this.mixtureSettings = false
      this.docSetting = false
      this.dateSetting = false
      this.audioSetting = false
    },

    scrollToLastTab() {
      this.$nextTick(() => {
        const tabsRef = this.$refs.tabs
        if (!tabsRef || !tabsRef.$el) return
        const lastTabElement = tabsRef.$el.querySelector('.van-tab:last-child')
        if (lastTabElement) {
          lastTabElement.scrollIntoView({ behavior: 'smooth' })
        }
      })
    },

    addTab() {
      this.showControl = true
    },

    onPickControl(content) {
      this.showControl = false

      this.$emit('add-control', content)
    },

    confirmRemoveTab(controlIndex, type) {
      Dialog.confirm({
        title: this.$t('append_field.del_title'),
        message: this.$t('append_field.del_message'),
      }).then(() => {
        this.$emit('remove-tab', { controlIndex, type })
      })
    },

    onTabTouchStart(event, index) {
      if (event.target.classList.contains('delete-icon')) return
      this.dragStartIndex = index
    },

    onTabTouchMove(event) {
      if (this.isDragging) {
        event.preventDefault()
        event.stopPropagation()
      }
    },


    onTabMouseDown(event, index) {
      if (event.target.classList.contains('delete-icon')) return
      this.dragStartIndex = index
    },

    showDatePicker(type) {
      if (type === 'sData') this.isShowStartData = true
      else if (type === 'eData') this.isShowEndData = true
      else if (type === 'sTime') this.isShowStartTime = true
      else if (type === 'eTime') this.isShowEndTime = true
    },

    formatter(date) {
      const y = date.getFullYear()
      const m = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`
      const d = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`
      return `${y}-${m}-${d}`
    },

    startDataChoose(res) {
      this.$emit('update:start-data', this.formatter(res))
      this.isShowStartData = false
    },

    endDataChoose(res) {
      this.$emit('update:end-data', this.formatter(res))
      this.isShowEndData = false
    },

    startTimeChoose(res) {
      this.$emit('update:start-time', `${res}:00`)
      this.isShowStartTime = false
    },

    endTimeChoose(res) {
      this.$emit('update:end-time', `${res}:00`)
      this.isShowEndTime = false
    },

    weekChoose(res) {
      this.$emit('toggle-week', res)
    },

    isMpListValid(index) {
      return Array.isArray(this.componentsList[index]?.mpList)
    },

    isTxListValid(index) {
      return Array.isArray(this.componentsList[index]?.txList)
    },

    ondele(index) {
      const ci = this.panelControlIndex
      if (ci < 0) return
      this.componentsList[ci].mpList.splice(index, 1)
    },

    close() {
      this.websetting = false
      this.subtitlesetting = false
    },

    getText(data) {
      this.addSubtitle({ data })
    },

    onClearBg() {
      this.bgImg = ''
      this.$emit('clear-bg')
    },
  },
}
</script>

<style scoped lang="scss">
.control-wrapper {
  position: absolute;
  width: 100%;
  background: #ffffff;
  overflow-x: hidden;
  white-space: nowrap;
  left: 0;

  &.is-tab-reordering {
    .playMode-content {
      overflow: hidden;
      pointer-events: none;
    }

    .tabs-container {
      overflow-x: auto;
      overflow-y: hidden;
    }
  }
}

.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.header {
  display: flex;
  width: 100%;
  height: 50px;
  position: relative;
}

.playMode-content {
  padding: 10px;
  height: calc(100% - 60px);
  overflow-y: auto;

  .list {
    margin-bottom: 20px;
  }

  .cell-title {
    height: 30px;
    line-height: 30px;
  }

  .progremList {
    overflow-y: auto;
    background: #fff;

    .van-radio {
      overflow: initial;
    }

    .van-radio-group--horizontal {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: row;
    }
  }

  .weekliWrap {
    display: flex;
    margin: 10px 0;
    justify-content: space-around;

    .weekli {
      width: 40px;
      height: 40px;
      background: #fff;
      border: 1px solid #006eff;
      color: #006eff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .weekli.active {
      background: #006eff;
      color: #fff;
    }
  }
}

.tabs-container {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
}

.custom-van-tabs {
  height: 100%;

  ::v-deep .van-tabs__wrap {
    overflow: hidden;
  }

  ::v-deep .van-tabs__nav--card {
    overflow-x: auto;
    overflow-y: hidden;
    touch-action: pan-x;
  }

  .van-tab {
    position: relative;
    transition: all 0.2s ease;

    .delete-icon {
      position: absolute;
      top: 2px;
      right: 2px;
      cursor: pointer;
       img {
        width: 20px;
        height: 20px;
      }
    }

    .tab-title-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      user-select: none;
      padding-right: 25px;
      cursor: grab;
      transition: transform 0.15s ease, opacity 0.15s ease;

      &:active {
        cursor: grabbing;
      }

      &--dragging {
        opacity: 0.75;
        transform: scale(1.06);
        z-index: 2;
      }

      &--drop-target {
        box-shadow: inset 3px 0 0 #006eff;
        background: rgba(0, 110, 255, 0.08);
      }
    }
  }
}

.tabs-btn {
  width: auto;
  display: flex;
  height: 100%;
  justify-content: flex-end;
  align-items: center;

  .van-button--default {
    border-left: 2px solid rgba(193, 193, 193, 0.45);
    width: 70px;
    background-color: rgba(215, 215, 215, 0.45) !important;
    height: 100%;
    border-radius: 0 !important;
  }
}

.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  .wrapper {
    padding: 0 16px;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    gap: 10px;
    max-width: 100%;
    max-height: 50%;
  }

  .icon-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(25% - 10px);
    box-sizing: border-box;
    text-align: center;
  }

  .overlay-text {
    max-width: 79px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .van-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  span {
    margin-top: 10px;
    display: inline-block;
    white-space: nowrap;
    color: #ffffff;
  }
}
</style>

<style lang="scss">
body.tab-reorder-lock {
  overflow: hidden;
  touch-action: none;
}
</style>
